import { Step } from '../types';

const BOOKING_STAGES: Step[] = ['lessons', 'days', 'times', 'tutors', 'confirm'];

export default BOOKING_STAGES;
